import {companyRegistrationApi} from '../client';

export const getMasterData = async (init?: RequestInit) =>
  companyRegistrationApi.getMaster(init);
